import { render, staticRenderFns } from "./SnoozePopup.vue?vue&type=template&id=596b4e6a&scoped=true"
import script from "./SnoozePopup.vue?vue&type=script&lang=js"
export * from "./SnoozePopup.vue?vue&type=script&lang=js"
import style0 from "./SnoozePopup.vue?vue&type=style&index=0&id=596b4e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b4e6a",
  null
  
)

export default component.exports